import blackPatchPerformanceDefaults from '../blackpatchperformance/config.js';

export default {
  ...blackPatchPerformanceDefaults,
  includes: ['shopify-generic', 'blackpatchperformance'],
  storeId: 'black-patch-performance-1',
};
